import { FiltersWithDropdown } from '@akyga/shared-ui/FiltersWithDropdown';

export default FiltersWithDropdown;
